import {Component, ElementRef, EventEmitter, Input, Output, QueryList, Renderer2, Self, ViewChildren} from '@angular/core';
import {ControlValueAccessor, NgControl,} from '@angular/forms';
import {RadioOption} from './radio-option';

/** Radio Button Identifier **/
let RADIO_ID = 0;

@Component({
  selector: 'valg-radio',
  templateUrl: './radio.component.html'
})
export class RadioComponent implements ControlValueAccessor{
  @ViewChildren('radio') public radioCollection!: QueryList<ElementRef>;

  @Input() public collection!: RadioOption[];
  @Input() errorKey: string | undefined;
  @Input() verticalRadio = false;
  @Output() changeEvent = new EventEmitter<boolean>();
  

  public id = `valg-radio-${RADIO_ID++}`;

  public onChange: any = () => {}
  public onTouched: any = () => {}

  public disabled = false;

  public checked = "";

  constructor(
    @Self() public control: NgControl,
    protected renderer: Renderer2
    ) {
    control.valueAccessor = this;
  }

  get formControl() {
    return this.control;
  }

  public ngAfterViewInit() {
    this.checkDisabledState();
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public writeValue(value: string) {
    this.checked = value;
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.checkDisabledState();
  }

  private checkDisabledState() {
    if (this.radioCollection && this.radioCollection.length > 0) {
      this.radioCollection.forEach((el) => {
        this.disabled
          ? this.renderer.setAttribute(el.nativeElement, 'disabled', String(this.disabled))
          : this.renderer.removeAttribute(el.nativeElement, 'disabled');
      });
    }
  }

  public valueChange(event: Event, object: RadioOption): void {
    if (this.disabled) {
      event.stopPropagation();
      return;
    }
    const v = this.collection.find((c) => c.value === object.value);
    this.checked = v?.value;
    this.onChange(v?.value);
    this.changeEvent.emit(v?.value);
  }

  public onFocusOut(): void {
    const v = this.collection.find((c) => c.value === this.control.value);
    if(v === undefined){
      this.changeEvent.emit();
    }
  }

  public onBlur(): void {
    this.onTouched();
  }
}